import { render } from "./ExtraEmployeeData.vue?vue&type=template&id=661ec03a&scoped=true&lang=true"
import script from "./ExtraEmployeeData.vue?vue&type=script&lang=js"
export * from "./ExtraEmployeeData.vue?vue&type=script&lang=js"

import "./ExtraEmployeeData.vue?vue&type=style&index=0&id=661ec03a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661ec03a"]])

export default __exports__